<template>
  <div class="account-settings-info-right">
    <div class="account-settings-info-title">
      <span>{{ $route.meta.subTitle }}</span>
    </div>
    <div>
      添加推广员前请 <span style="color: red">认真阅读</span> 一下文字
      谢谢配合:<br />
      为减少重复用户
      <span style="color: red">防止歧义出现</span>
      各地市需要添加到县区的推广码时需要按照以下
      <span style="color: red">规则</span> 进行添加<br />
      <span style="color: red">工号-> 必须为拼音 使用新工号</span>
      以潍坊高密为例: weifanggaomi<br />
      <span style="color: red">姓名-> 必须为中文</span> 以潍坊高密为例:
      潍坊高密<br />
      添加到活动中的显示为↓
      <img :src="info" alt="" />
    </div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      layout="horizontal"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="所属地区" prop="area_path">
        <!-- 联机选择器 -->
        <a-cascader
          style="width: 328px"
          :options="areaTree"
          v-model="form.area_path"
          :field-names="{ label: 'name', value: 'id', children: 'children' }"
          placeholder="请选择用户所属地区"
          :change-on-select="true"
          @change="onCaChange"
        />
      </a-form-model-item>

      <a-form-model-item label="管理地区" prop="area">
        <a-tree
          v-model="form.area"
          :tree-data="areaTree"
          :replace-fields="{ title: 'name', key: 'id' }"
          :checkable="true"
          @check="onCheck"
        />
      </a-form-model-item>
      <a-form-model-item label="工号" prop="username">
        <a-input
          class="vd-input-s"
          v-model="form.username"
          placeholder="工号"
        />
      </a-form-model-item>

      <a-form-model-item label="姓名" prop="nickname">
        <a-input
          class="vd-input-s"
          v-model="form.nickname"
          placeholder="姓名"
        />
      </a-form-model-item>
    </a-form-model>
    <!--    <a-button>-->
    <a-button type="primary" style="margin-right: 8px" @click="add">
      保存
    </a-button>
    <!--      重置-->
    <!--    </a-button>-->
  </div>
</template>

<script>
import { generalUser } from "@/api";
import { getRoleApi, get_area_tree } from "@/api/auth";
import info from "@/assets/info.jpg";

export default {
  name: "addAdmin",
  data() {
    return {
      info,
      areaTree: [],
      roleList: [],
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      form: {
        id: 0,
        area: [],
        username: "",
        nickname: "",
        area_path: [], // 管理地区
      },
      rules: {
        username: [{ required: true, message: "请输入工号", trigger: "blur" }],
        nickname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
    };
  },
  created() {
    // let user_info = JSON.parse(localStorage.getItem('USER_INFO'))
    // console.log(user_info)
    // 获取角色组 信息
    getRoleApi().then((res) => {
      if (res.code === 1) {
        this.roleList = res.list;
      }
    });
    // 获取管理地区信息
    get_area_tree().then((res) => {
      if (res["code"] === 1) {
        this.areaTree = res["areaTree"];
      }
    });
  },
  methods: {
    add: function() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          generalUser(this.form).then((res) => {
            if (res["code"] === 1) {
              this.$message.success(res["msg"]);
            } else {
              this.$message.warning(res["msg"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    onCaChange(checkedKeys) {
      this.form.area_path = checkedKeys;
    },
    onCheck(checkedKeys) {
      this.form.area = checkedKeys;
    },
  },
};
</script>

<style scoped></style>
